import {
  ActiveAlarm,
  Activity,
  Alarm,
  Auth,
  Config,
  Contact,
  ContactGroup,
  Device,
  Event,
  Location,
  Notification,
  Room,
  Scanner,
  Upload,
  Version,
  defineWebSocketServices,
  orchestrateWebSocketAndServices,
} from '@evac/shared'
import { storage } from './storage'

const services = defineWebSocketServices(
  [Auth.service.userInfo, storage.memory],
  [Auth.service.tokenDetail, storage.memory],
  [Config.service, storage.memory],
  [Location.service, storage.memory],
  [Room.service, storage.memory],
  [Scanner.service, storage.memory],
  [Device.service, storage.memory],
  [Activity.service, storage.memory],
  [Notification.service, storage.memory],
  [Alarm.service, storage.memory],
  [ActiveAlarm.service, storage.memory],
  [Event.service, storage.memory],
  [Contact.service, storage.memory],
  [ContactGroup.service, storage.memory],
  [Upload.service, storage.memory],
  [Version.service, storage.memory]
)

/**
 * Bind storage to every service before the app mounts, so REST data loaded by
 * route guards is persisted and observable independently of the WebSocket
 * handshake (which is what `start` waits for). Without this the bootstrap data
 * set before the WS opens was dropped, leaving an empty overview after a refresh.
 */
export function primeServices() {
  for (const [service, storage] of services) {
    service.prime(storage)
  }
}

export default function handleServicesOverWebSocket(url: URL | string) {
  orchestrateWebSocketAndServices({ url, services, tokenProvider: Auth.getCurrentToken })
}
